
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class ContentSkeleton extends Vue {
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
